import { IAvalancheDangerScale } from 'redux-state/avalanche-advisory/types.js';

const getDangerScale = (danger: Array<IAvalancheDangerScale>, id: number): IAvalancheDangerScale | undefined =>
  danger.find(({ danger_id }) => id === danger_id); // eslint-disable-line

export { getDangerScale };
